import { swup } from '@/website/lib/swup'
import { breakpointsTailwind, useBreakpoints, useScroll } from '@vueuse/core'
import { computed, ref, watch } from 'vue'

const breakpoints = useBreakpoints(breakpointsTailwind)
const lgAndGreater = breakpoints.greater('lg')

const isScrollingUpLazy = ref(false)
const { arrivedState, y } = useScroll(window)

const isOverlayNav = ref(false)

// const activeNavLinkIds = ref<string[]>([])

export const useNavContext = (initialNavMode?: string) => {
    if (typeof initialNavMode !== 'undefined') {
        isOverlayNav.value = initialNavMode === 'overlay'
    }

    const checkOverlayNav = (el: Element | Document) => {
        const mainNavModeMeta = el.querySelector('meta[name="main-nav-mode"]')

        isOverlayNav.value = mainNavModeMeta?.getAttribute('content') === 'overlay'
    }

    // const checkActiveNavLinkIds = (el: Element | Document) => {
    //     const metaTag = el.querySelector('meta[name="active-nav-links"]')

    //     activeNavLinkIds.value = metaTag?.getAttribute('content')?.split(',') ?? []
    // }

    const isSolidColorNav = computed(() => {
        if (arrivedState.top) {
            return false
        }
        if (!lgAndGreater.value ? y.value <= 100 : y.value <= 150) {
            return false
        }
        return true
    })

    const isNavHidden = computed(() => {
        if (arrivedState.top) {
            return false
        }
        if (isScrollingUpLazy.value) {
            return false
        }
        if (!lgAndGreater.value ? y.value <= 300 : y.value <= 400) {
            return false
        }

        return true
    })

    // The directions in the `useScroll` composable resets when the user stops scrolling
    // We need to keep track of the scroll direction
    watch(y, (newY, oldY) => {
        if (newY < oldY) {
            isScrollingUpLazy.value = true
        }

        if (newY > oldY) {
            isScrollingUpLazy.value = false
        }
    })

    watch(isNavHidden, (newValue) => {
        document.body.style.setProperty('--egnc-nav-hidden-multiplier', newValue ? '0' : '1')
    })

    swup.hooks.on('content:replace', (visit) => {
        if (visit.to.document) {
            checkOverlayNav(visit.to.document)
            // checkActiveNavLinkIds(visit.to.document)
        }
    })

    // checkActiveNavLinkIds(document)

    document.body.style.setProperty('--egnc-nav-hidden-multiplier', isNavHidden.value ? '0' : '1')

    return {
        isSolidColorNav,
        isOverlayNav,
        // activeNavLinkIds,
        isNavHidden,
    }
}
